import { isValidDateOnly } from "./date-only.js";

export const JURISPRUDENCE_TRIBUNALS = [
  { value: "all", label: "Todos los tribunales" },
  { value: "supreme", label: "Suprema Corte" },
  { value: "civil_appeals", label: "Cámaras civiles" },
  { value: "labor", label: "Cámaras del Trabajo" },
  { value: "civil", label: "Juzgados civiles" },
  { value: "peace", label: "Juzgados de Paz" },
  { value: "tax", label: "Juzgados tributarios" },
  { value: "bankruptcy", label: "Juzgados concursales" },
];

const validTribunals = new Set(
  JURISPRUDENCE_TRIBUNALS.map(({ value }) => value),
);

export function jurisprudenceSearchFromUrl(search = "") {
  const parameters = new URLSearchParams(search);
  const tribunal = parameters.get("tribunal") || "all";
  const fromDate = parameters.get("from") || "";
  const toDate = parameters.get("to") || "";
  return {
    query: (parameters.get("q") || "").trim(),
    tribunal: validTribunals.has(tribunal) ? tribunal : "all",
    fromDate: isValidDateOnly(fromDate) ? fromDate : "",
    toDate: isValidDateOnly(toDate) ? toDate : "",
  };
}

export function buildJurisprudenceSearchUrl({
  query,
  tribunal = "all",
  fromDate = "",
  toDate = "",
}) {
  const parameters = new URLSearchParams({ q: query.trim() });
  if (tribunal !== "all") parameters.set("tribunal", tribunal);
  if (fromDate) parameters.set("from", fromDate);
  if (toDate) parameters.set("to", toDate);
  return `/jurisprudencia?${parameters}`;
}
